// Portuguese translations
export const pt: Record<string, string> = {
  // Main Menu
  'menu.dashboard': 'Painel',
  'menu.orderNew': 'Registro de Produto',
  'menu.deliveryList': 'Lista de Entrega',
  'menu.delivery': 'Entrega',
  'menu.receipt': 'Imprimir Recibo/Etiqueta',
  'menu.carWash': 'Lavagem auto',
  'menu.referral': 'Convidar',
  'menu.barber': 'Barbearia / Cabeleireiro',
  'menu.definitions': 'Definições',
  'menu.customers': 'Clientes',
  'menu.products': 'Definições de Produtos',
  'menu.pricing': 'Definições de Preços',
  'menu.tailoring': 'Operações de Alfaiataria',
  'menu.attributes': 'Atributos de Produtos',
  'menu.users': 'Usuários',
  'menu.productOrdering': 'Ordenação de Produtos',
  'menu.discounts': 'Definições de Descontos',
  'menu.settings': 'Configurações',
  'menu.generalSettings': 'Configurações Gerais',
  'menu.permissions': 'Gestão de Permissões',
  'menu.subscription': 'Assinatura',
  'menu.invoices': 'Gestão de Faturas',
  'menu.expenses': 'Entrada de Despesas',
  'menu.zReport': 'Z Report',
  'menu.reportsAndAccounting': 'Relatórios e Contabilidade',
  'menu.systemAndCommunication': 'Sistema e Comunicação',
  'menu.reportsList': 'Lista de Recibos',
  'menu.accountStatement': 'Extrato de Conta',
  'menu.tickets': 'Solicitações de Suporte',
  'menu.support': 'Suporte',
  'menu.profile': 'Perfil',
  'menu.logout': 'Sair',
  'menu.notifications': 'Notificações SMS/WhatsApp',
  'menu.whatsappConnection': 'Conexão WhatsApp',
  'menu.smsConnection': 'Conexão SMS',
  
  // Dashboard
  'dashboard.title': 'Painel',
  'dashboard.todaySales': 'Vendas de Hoje',
  'dashboard.totalOrders': 'Total de Pedidos',
  'dashboard.pendingDeliveries': 'Entregas Pendentes',
  'dashboard.activeCustomers': 'Clientes Ativos',
  'dashboard.recentOrders': 'Pedidos Recentes',
  'dashboard.viewAll': 'Ver Tudo',
  'dashboard.quickActions': 'Ações Rápidas',
  'dashboard.newOrder': 'Novo Pedido',
  'dashboard.newCustomer': 'Novo Cliente',
  'dashboard.deliveries': 'Entregas',
  'dashboard.reports': 'Relatórios',
  'dashboard.today': 'Hoje',
  'dashboard.yesterday': 'Ontem',
  'dashboard.week': 'Semana',
  'dashboard.month': 'Mês',
  'dashboard.quarter': 'Trimestre',
  'dashboard.year': 'Ano',
  'dashboard.totalRevenue': 'Receita Total',
  'dashboard.totalOrdersCard': 'Total de Pedidos',
  'dashboard.totalPieces': 'Total de Peças',
  'dashboard.cancelled': 'Cancelado',
  'dashboard.inProcess': 'Em Andamento',
  'dashboard.inProcessDesc': 'Pedidos em andamento',
  'dashboard.ready': 'Pronto',
  'dashboard.readyDesc': 'Pedidos prontos para entrega',
  'dashboard.delivered': 'Entregue',
  'dashboard.deliveredDesc': 'Pedidos concluídos',
  'dashboard.announcements': 'Anúncios',
  'dashboard.announcementAll': 'Geral',
  'dashboard.announcementPrivate': 'Privado',
  
  // Order Entry
  'order.title': 'Novo Pedido',
  'order.customer': 'Cliente',
  'order.selectCustomer': 'Selecionar Cliente',
  'order.newCustomer': 'Novo Cliente',
  'order.products': 'Produtos',
  'order.addProduct': 'Adicionar Produto',
  'order.selectProduct': 'Selecionar Produto',
  'order.quantity': 'Quantidade',
  'order.price': 'Preço',
  'order.total': 'Total',
  'order.discount': 'Desconto',
  'order.subtotal': 'Subtotal',
  'order.tax': 'IVA',
  'order.grandTotal': 'Total Geral',
  'order.payment': 'Pagamento',
  'order.paymentMethod': 'Método de Pagamento',
  'order.cash': 'Dinheiro',
  'order.card': 'Cartão de Crédito',
  'order.credit': 'A Crédito',
  'order.amountPaid': 'Valor Pago',
  'order.remainingBalance': 'Saldo Restante',
  'order.deliveryDate': 'Data de Entrega',
  'order.notes': 'Notas',
  'order.createOrder': 'Criar Pedido',
  'order.cancel': 'Cancelar',
  
  // Users
  'users.title': 'Usuários',
  'users.addNew': 'Novo Usuário',
  'users.name': 'Nome',
  'users.email': 'E-mail',
  'users.role': 'Função',
  'users.pin': 'PIN',
  'users.permissions': 'Permissões',
  'users.allPermissions': 'Todas as Permissões',
  'users.permissionCount': '{count} permissões',
  'users.changePin': 'Alterar PIN',
  'users.edit': 'Editar',
  'users.delete': 'Excluir',
  'users.newUser': 'Novo Usuário',
  'users.editUser': 'Editar Usuário',
  'users.editingUser': 'Editando {name}',
  'users.deleteUserTitle': 'Excluir Usuário',
  'users.deletingUser': 'Tem certeza de que deseja excluir {name}?',
  'users.pinCode': 'Código PIN (4-6 dígitos)',
  'users.selectRole': 'Selecionar função',
  'users.patron': 'Proprietário',
  'users.kasiyer': 'Caixa',
  'users.sofor': 'Motorista',
  'users.eleman': 'Funcionário',
  'users.changePinTitle': 'Alterar Código PIN',
  'users.newPin': 'Novo Código PIN',
  'users.confirmPin': 'Confirmar Código PIN',
  'users.pinMismatch': 'Os códigos PIN não correspondem',
  'users.pinRequired': 'Código PIN obrigatório',
  'users.pinLength': 'O código PIN deve ter 4-6 dígitos',
  'users.changingPinFor': 'Alterando PIN para {name}',
  
  // Products
  'products.title': 'Definições de Produtos',
  'products.addNew': 'Novo Produto',
  'products.category': 'Categoria',
  'products.name': 'Nome do Produto',
  'products.price': 'Preço',
  'products.color': 'Cor',
  'products.active': 'Ativo',
  'products.actions': 'Ações',
  'products.search': 'Pesquisar Produto...',
  'products.noProducts': 'Nenhum produto encontrado',
  'products.noCategoryProducts': 'Nenhum produto nesta categoria',
  'products.emptyCart': 'Carrinho vazio',
  
  // Service Types
  'service.tailor': 'Alfaiataria',
  'service.dryCleaning': 'Lavagem a Seco',
  'service.washing': 'Lavagem',
  'service.ironing': 'Passar',
  'service.dyeing': 'Tingimento',
  'pricing.dyeing': 'Tingimento',
  'service.shoeShine': 'Engraxar Sapatos',
  'service.carpet': 'Tapete',
  'service.tailoring': 'Ajustes de Alfaiataria',
  'service.carpetWashing': 'Lavagem de Tapetes',
  'service.sofaWashing': 'Lavagem de Sofás',
  'service.carWash': 'Lavagem de Carros & Detailing',
  'service.barber': 'Barbearia / Cabeleireiro',
  'service.selectService': 'Selecionar serviço',
  'service.addToCart': 'Adicionar ao Carrinho',
  'service.total': 'Total',
  
  // Common
  'common.yes': 'Sim',
  'common.no': 'Não',
  'common.cancel': 'Cancelar',
  'common.confirm': 'Confirmar',
  'common.delete': 'Excluir',
  'common.edit': 'Editar',
  'common.save': 'Salvar',
  'common.search': 'Pesquisar',
  'common.loading': 'Carregando...',
  'common.noData': 'Sem dados',
  'common.actions': 'Ações',
  'common.status': 'Status',
  'common.date': 'Data',
  'common.time': 'Hora',
  'common.total': 'Total',
  'common.filter': 'Filtrar',
  'common.export': 'Exportar',
  'common.print': 'Imprimir',
  'common.close': 'Fechar',
  'common.back': 'Voltar',
  'common.next': 'Próximo',
  'common.previous': 'Anterior',
  'common.submit': 'Enviar',
  'common.reset': 'Redefinir',
  'common.create': 'Criar',
  'common.creating': 'Criando...',
  'common.later': 'Mais tarde',
  'common.clear': 'Limpar',
  'common.copied': 'Copiado!',
  'common.copyError': 'Falha ao copiar',
  'common.perPage': 'Por página',
  'common.page': 'Página',
  'common.orders': 'Pedidos',
  'common.pieces': 'peças',
  
  // Login
  'login.title': 'Cleandy',
  'login.subtitle': 'Sistema de Gestão de Lavanderia a Seco',
  'login.tenantId': 'ID da Empresa',
  'login.tenantPlaceholder': 'id-empresa (ex: acme-clean)',
  'login.tenantIdHelp': 'Digite seu identificador único da empresa',
  'login.continue': 'Continuar →',
  'login.notMember': 'Ainda não é membro?',
  'login.startTrial': 'Iniciar Teste Grátis',
  'login.adminLogin': '🔒 Login de Administrador',
  'login.enterPin': 'Digite seu código PIN',
  'login.changeTenant': 'Mudar Empresa',
  'login.clear': 'Limpar',
  'login.delete': 'Excluir',
  'login.login': 'Entrar',
  'login.loggingIn': 'Entrando...',
  'login.defaultPinOwner': 'PIN padrão: <strong>1234</strong> (Proprietário)',
  'login.defaultPinCashier': 'PIN padrão: <strong>0000</strong> (Caixa)',
  'login.systemInitializing': 'Inicializando sistema...',
  'login.pinMinLength': 'O PIN deve ter pelo menos 4 dígitos',
  'login.invalidTenantId': 'Digite um ID de empresa válido',
  'login.tenantNotFound': 'Este código de empresa não foi encontrado. Verifique ou crie uma nova conta.',
  'login.loginFailed': 'Falha no login',
  'login.welcome': 'Bem-vindo, {name}',

  // Signup translations
  'signup.title': 'Iniciar Teste Grátis',
  'signup.subtitle': 'Teste grátis de 15 dias, sem necessidade de cartão de crédito',
  'signup.backToLogin': 'Voltar à Página de Login',
  'signup.companyCode': 'Código da Empresa',
  'signup.companyCodePlaceholder': 'ex: cleanpro',
  'signup.companyCodeHelp': 'Este código será usado para fazer login no sistema',
  'signup.companyCodeMinLength': 'O código da empresa deve ter pelo menos 3 caracteres',
  'signup.companyName': 'Nome da Empresa',
  'signup.companyNamePlaceholder': 'Nome da Sua Empresa',
  'signup.companyNameRequired': 'O nome da empresa é obrigatório',
  'signup.fullName': 'Nome Completo',
  'signup.fullNamePlaceholder': 'Seu Nome Completo',
  'signup.fullNameRequired': 'O nome completo é obrigatório',
  'signup.phone': 'Telefone',
  'signup.phonePlaceholder': '+55 11 98765-4321',
  'signup.validPhoneRequired': 'Digite um número de telefone válido',
  'signup.email': 'E-mail',
  'signup.emailPlaceholder': 'exemplo@empresa.com',
  'signup.validEmailRequired': 'Digite um endereço de e-mail válido',
  'signup.createAccount': 'Criar Conta',
  'signup.creating': 'Criando...',
  'signup.terms': 'Ao criar uma conta, você concorda com os Termos de Serviço e a Política de Privacidade.',
  'signup.success': 'Registro bem-sucedido! Suas informações de login foram enviadas para seu endereço de e-mail.',
  'signup.successTitle': 'Registro Bem-Sucedido!',
  'signup.successMessage': 'Sua conta foi criada com sucesso.',
  'signup.emailSent': 'Suas informações de login foram enviadas para seu endereço de e-mail.',
  'signup.redirecting': 'Redirecionando para a página de login...',
  'signup.startupPackageLoaded': 'Pacote Inicial Carregado!',
  'signup.products': 'Produtos',
  'signup.customers': 'Clientes',
  'signup.users': 'Usuários',
  'signup.demoDataReady': '✨ Seus dados de demonstração estão prontos, você pode começar a usá-los imediatamente!',
  'signup.loginInfo': '📧 Suas Informações de Login',
  'signup.loginInfoSent': '💡 Estas informações também foram enviadas para seu endereço de e-mail',
  'signup.loginNow': 'Entrar Agora →',
  'signup.hints.companyCode': 'Usado para login',
  'signup.hints.country': 'Seu país foi detectado automaticamente. Você pode selecionar um país diferente.',
  'signup.freeTrial': '🎉 Teste grátis por 15 dias - Não precisa de cartão de crédito!',
  'signup.businessType.question': 'Que tipo de negócio você tem?',
  'signup.businessType.hint': 'Sua tela padrão será definida automaticamente com base na sua seleção',
  'signup.businessType.continue': 'Continuar',
  'signup.bt.dryCleaning.desc': 'Limpeza de roupas, cortinas e têxteis',
  'signup.bt.carpetWashing.desc': 'Lavagem de tapetes, kilims e passadeiras',
  'signup.bt.shoeShine.desc': 'Limpeza e cuidado de calçados',
  'signup.bt.sofaWashing.desc': 'Limpeza de sofás, poltronas e cadeiras',
  'signup.bt.carWash.desc': 'Lavagem, polimento e cuidados com veículos',
  'signup.bt.tailoring.desc': 'Alfaiataria, ajustes e serviços de costura',
  'signup.bt.barber.desc': 'Cabeleireiro, barbeiro e salão de beleza',
  'signup.bt.tailoring.desc': 'Alfaiataria, ajustes e costura',
  'signup.bt.barber.desc': 'Cabeleireiro, barbearia e salão de beleza',

  // Toast Messages
  'toast.usernameRequired': 'Nome de usuário obrigatório',
  'toast.firstLoginChangePin': '⚠️ Primeiro login - Por favor, mude seu código PIN',
  'toast.tenantNotFound': 'Empresa não encontrada: "{tenantId}"\\n\\nClique em "Iniciar Teste Grátis" para criar uma nova conta de empresa.',
  'toast.tenantIdNotRemembered': '🗑️ O ID da empresa não será lembrado',
  'toast.demoDataLoaded': 'Usuários demo, produtos, clientes e pedidos criados!',
  'toast.productsLoadError': 'Erro ao carregar produtos',
  'toast.statsLoadError': 'Erro ao carregar estatísticas',
  'toast.deliveryBeforeToday': 'A data de entrega não pode ser anterior a hoje',
  'toast.customerOpenOrders': 'O cliente tem {count} pedidos abertos',
  'toast.customerDebt': 'O cliente tem uma dívida de {amount}',
  'toast.customerSaved': 'Cliente salvo',
  'toast.customerSaveError': 'Erro ao salvar cliente',
  'toast.customerUpdated': 'Cliente atualizado',
  'toast.customerUpdateError': 'Erro ao atualizar cliente',
  'toast.customerExistingSelected': 'Cliente existente selecionado',
  'toast.productAddedToCart': 'Produto adicionado ao carrinho',
  'toast.productAdded': 'Produto adicionado',
  'toast.productDetailsUpdated': 'Detalhes do produto atualizados',
  'toast.priceUpdated': 'Preço atualizado',
  'toast.selectAtLeastOneService': 'Selecione pelo menos um serviço',
  'toast.selectCustomer': 'Selecione um cliente',
  'toast.addProduct': 'Adicione um produto',
  'toast.addressRequiredForDelivery': 'Endereço necessário para entrega',
  'toast.orderSaved': 'Pedido salvo',
  'toast.orderSaveError': 'Erro ao salvar pedido',
  'toast.cardPaymentSuccess': 'Pagamento com cartão bem-sucedido!',
  'toast.cardPaymentError': 'Falha no pagamento com cartão',
  'toast.paymentFailedTryAgain': 'Pagamento falhou. Tente novamente.',
  'toast.paymentStatusCheckFailed': 'Não foi possível verificar o status do pagamento.',
  'toast.customerPhoneNotFound': 'Telefone do cliente não encontrado',
  'toast.whatsappSent': 'Mensagem WhatsApp enviada! ✅',
  'toast.whatsappFailed': 'Falha ao enviar mensagem WhatsApp',
  'toast.orderUpdateError': 'Falha ao atualizar pedido',
  'toast.searchError': 'Erro de busca',
  'toast.orderNotFound': 'Pedido não encontrado',
  'toast.editCancelled': 'Edição cancelada',
  'toast.noEditPermission': 'Você não tem permissão para editar pedidos passados',
  'toast.selectAtLeastOneOperation': 'Selecione pelo menos uma operação',
  'toast.tailorAddedToCart': 'Operação de alfaiataria adicionada ao carrinho',
  'toast.enterValidArea': 'Insira uma área válida',
  'toast.enterValidAmount': 'Insira um valor válido',
  'toast.amountExceedsRemaining': 'O valor não pode exceder o saldo restante',
  'toast.fillAllCardInfo': 'Preencha todas as informações do cartão',
  'toast.invalidCardNumber': 'Número de cartão inválido',
  'toast.invalidMonth': 'Mês inválido (deve ser 1-12)',
  'toast.invalidYear': 'Ano inválido',
  'toast.invalidCvc': 'CVC inválido',

  // Settings
  'settings.title': 'Configurações',
  'settings.save': 'Salvar',
  'settings.loading': 'Carregando...',
  'settings.general': 'Configurações gerais',
  'settings.languageRegion': 'Idioma e região',
  'settings.language': 'Idioma',
  'settings.currency': 'Moeda',
  'settings.currencyPosition': 'Posição da moeda',
  'settings.currencyPositionLeft': 'Esquerda (R$100)',
  'settings.currencyPositionRight': 'Direita (100R$)',
  'settings.numberFormat': 'Formato numérico',
  'settings.numberFormatDotComma': 'Ponto para decimais (1.234,56)',
  'settings.numberFormatCommaDot': 'Vírgula para decimais (1,234.56)',
  'settings.numberFormatSpaceComma': 'Espaço para decimais (1 234,56)',
  'settings.showDecimals': 'Mostrar decimais',
  'settings.showDecimalsDesc': 'Mostrar 2 decimais para valores',
  'settings.dateFormat': 'Formato de data',
  'settings.timezone': 'Fuso horário',
  'settings.taxRate': 'Taxa de imposto',
  'settings.receiptSettings': 'Configurações do recibo',
  'settings.logo': 'Logo',
  'settings.removeLogo': 'Remover logo',
  'settings.uploadLogo': 'Carregar logo',
  'settings.companyName': 'Nome da empresa',
  'settings.companyNamePlaceholder': 'Digite o nome da empresa',
  'settings.phone': 'Telefone',
  'settings.address': 'Endereço',
  'settings.addressPlaceholder': 'Digite o endereço',
  'settings.footerText': 'Texto do rodapé',
  'settings.footerTextPlaceholder': 'Digite o texto do rodapé',
  'settings.receiptNote': 'Nota do recibo',
  'settings.receiptNotePlaceholder': 'Digite a nota do recibo',
  'settings.socialMedia': 'Redes sociais',
  'settings.website': 'Site',
  'settings.dangerZone': 'Zona de perigo',
  'settings.deleteDemoData': 'Excluir dados de demo',
  'settings.deleteDemoDataTitle': 'Excluir dados de demo',
  'settings.deleteDemoDataConfirm': 'Esta ação não pode ser anulada! Os clientes de exemplo e os seus recibos/pagamentos serão eliminados; os seus próprios clientes e recibos serão mantidos.',
  'toast.noDemoData': 'Não foram encontrados clientes de exemplo para eliminar.',
  'toast.demoCustomersKept': '{n} cliente(s) de exemplo mantido(s) porque têm recibos criados por si; apenas os recibos de exemplo foram eliminados.',
  'toast.demoDataDeleted': 'Dados de exemplo eliminados',
  'settings.deleteDemoDataWarning': 'Remove os clientes de exemplo adicionados automaticamente na configuração, juntamente com os seus recibos e pagamentos. Os clientes e recibos que adicionou não são eliminados.',
  'settings.productsWillBeKept': 'Produtos serão mantidos',
  'settings.areYouSure': 'Tem certeza?',
  'settings.deleting': 'Excluindo...',
  'settings.loadSchema': 'Carregar esquema',
  'settings.loadSchemaTitle': 'Carregar esquema do banco de dados',
  'settings.loadSchemaConfirm': 'Isso criará o esquema do banco de dados. Continuar?',
  'settings.connected': 'Conectado',
  'settings.notConnected': 'Não conectado',
  'settings.connect': 'Conectar',
  'settings.disconnect': 'Desconectar',
  'settings.showTax': 'Mostrar imposto',
  'settings.headerInfo': 'Info do cabeçalho',
  'settings.headerInfoPlaceholder': 'ex: Limpeza a seco e Passar',
  'settings.footerTextHelp': 'Mensagem curta no rodapé do recibo',
  'settings.receiptNoteHelp': 'Termos e condições detalhados',
  'settings.receiptPreview': 'Prévia do recibo',
  'settings.expenses': 'Despesas',
  'settings.invoices': 'Faturas',
  'settings.reports': 'Relatórios',
  'settings.tickets': 'Tickets de suporte',
  'settings.zReport': 'Z Report',

  // Receipt Page
  'receipt.title': 'Recibo',
  'receipt.receiptNumber': 'N° recibo',
  'receipt.date': 'Data',
  'receipt.subtotal': 'Subtotal',
  'receipt.payment': 'Pagamento',
  'receipt.thankYou': 'Obrigado!',

  // Chaves comuns faltando
  'common.allYears': 'Todos os anos',
  'common.autoDetected': 'Detectado automaticamente',
  'common.cancelled': 'Cancelado',
  'common.clear': 'Limpar',
  'common.items': 'Itens',
  'common.loadError': 'Não foi possível carregar',
  'common.none': 'Nenhum',
  'common.paid': 'Pago',
  'common.searchError': 'Erro de pesquisa',
  'common.searchResults': '(Resultados da pesquisa)',
  'common.unit': 'Unidade',
  'common.year': 'Ano',

  // Extrato de conta
  'accountStatement.allTime': 'Todo o período',
  'accountStatement.customer': 'Cliente',
  'accountStatement.customerReceipts': 'Recibos do cliente',
  'accountStatement.noData': 'Nenhum extrato encontrado',
  'accountStatement.noReceipts': 'Nenhum recibo encontrado',
  'accountStatement.payments': 'Pagamentos',
  'accountStatement.period': 'Período',
  'accountStatement.printStatement': 'Imprimir extrato',
  'accountStatement.receipts': 'Recibos',
  'accountStatement.remaining': 'Saldo restante',
  'accountStatement.statement': 'Extrato de conta',
  'accountStatement.totalPaid': 'Total pago',

  // Atributos
  'attributes.color': 'Cor',
  'attributes.deleteError': 'Não foi possível excluir o atributo',
  'attributes.deleted': 'Atributo excluído',
  'attributes.name': 'Nome do atributo',
  'attributes.noAttributes': 'Nenhum atributo definido',
  'attributes.saveError': 'Não foi possível salvar os atributos',
  'attributes.saved': 'Atributos salvos',
  'attributes.value': 'Valor',

  // Extrato do cliente
  'customerStatement.receiptDelivered': 'Entregue',
  'customerStatement.receiptOpen': 'Aberto',

  // Clientes
  'customers.add': 'Adicionar cliente',
  'customers.adres': 'Endereço',
  'customers.cannotDeleteWithOrders': 'Não é possível excluir cliente com pedidos',
  'customers.legacyHidden': 'Oculto (Legado)',
  'customers.notFound': 'Cliente não encontrado',
  'customers.phoneMissing': 'Número de telefone ausente',
  'customers.telefon': 'Telefone',
  'customers.telefon2': 'Telefone 2',

  // Danos
  'damage.add': 'Adicionar dano',
  'damage.description': 'Descrição',
  'damage.location': 'Localização',
  'damage.noPhoto': 'Sem foto',
  'damage.photo': 'Foto',
  'damage.saveError': 'Não foi possível salvar o relatório de dano',
  'damage.saved': 'Relatório de dano salvo',
  'damage.severity': 'Gravidade',
  'damage.title': 'Relatório de dano',
  'damage.type': 'Tipo de dano',

  // Painel
  'dashboard.allTime': 'Todo o período',
  'dashboard.referral.button': 'Copiar link de convite',
  'dashboard.referral.desc': '1 mês extra quando um negócio convidado se registar!',
  'dashboard.referral.title': 'Convidar amigos',

  // Entrega
  'delivery.complete': 'Entregar',
  'delivery.deliveredItems': 'Itens entregues',
  'delivery.deliveredProducts': 'Produtos entregues',
  'delivery.error': 'Erro de entrega',
  'delivery.noOrders': 'Nenhum pedido encontrado',
  'delivery.success': 'Entrega realizada com sucesso',

  // Lista de entrega
  'deliveryList.address': 'Endereço',
  'deliveryList.cancelButton': 'Cancelar',
  'deliveryList.cancelTitle': 'Cancelar pedido',
  'deliveryList.complete': 'Concluir',
  'deliveryList.completed': 'Concluído',
  'deliveryList.delivered': 'Entregue',
  'deliveryList.driver': 'Motorista',
  'deliveryList.items': 'Itens',
  'deliveryList.orderCancelled': 'Pedido cancelado',
  'deliveryList.orderDelivered': 'Pedido entregue',
  'deliveryList.pending': 'Pendente',
  'deliveryList.phone': 'Telefone',
  'deliveryList.selectDriver': 'Selecionar motorista',
  'deliveryList.status': 'Status',
  'deliveryList.title': 'Lista de entregas',

  // Motorista
  'driver.searchHint': 'Digite pelo menos 2 caracteres',
  'driver.searchPlaceholder': 'N° recibo, nome ou telefone...',

  // Rodapé
  'footer.euServers': 'Servidores UE',
  'footer.gdpr': 'Conformidade com LGPD/GDPR',

  // Faturas
  'invoices.downloading': 'Baixando...',

  // Login
  'login.credentialsTitle': 'Credenciais',
  'login.enterCredentials': 'Inserir credenciais',
  'login.forget': 'Esqueceu a senha?',
  'login.saveCredentialsNote': 'Credenciais salvas com segurança',
  'login.tagline': 'Software de lavanderia — Soluções inteligentes para o seu negócio.',
  'login.usernamePlaceholder': 'Digite o nome de usuário...',

  // Menu
  'menu.driverPickup': 'Coleta pelo motorista',
  'menu.hardware': 'Hardware',
  'menu.payment': 'Pagamento',
  'menu.reportsCharts': 'Relatórios e gráficos',

  // Navegação
  'nav.logout': 'Sair',
  'nav.user': 'Usuário',

  // Pedido
  'order.amount': 'Valor',
  'order.homeDelivery': 'Entrega em domicílio',
  'order.processing': 'Processando...',
  'orderCreate.selectOperation': 'Selecionar operação',
  'orderCreate.selectedOperations': 'Operações selecionadas',

  // Pagamento
  'payment.bank': 'Transferência bancária',
  'payment.adjustment': 'Ajuste de saldo',
  'payment.collect': 'Cobrar',
  'payment.credit': 'Crédito',
  'payment.free': 'Grátis',
  'payment.paymentCare': 'Pagamento de conta',
  'payment.paymentsSaved': 'Pagamentos salvos',
  'payment.saveError': 'Não foi possível salvar pagamentos',
  'payment.saved': 'Pagamento salvo',
  'payment.split': 'Pagamento dividido',

  // Espaços reservados
  'placeholder.customerAddress': 'Digite o endereço...',
  'placeholder.customerEmail': 'Digite o e-mail...',
  'placeholder.customerName': 'Digite o nome...',
  'placeholder.customerNotes': 'Digite as observações...',
  'placeholder.customerPhone': 'Digite o telefone...',

  // Precificação
  'pricing.amount': 'Valor',
  'pricing.enterPrice': 'Digite o preço',
  'pricing.percent': 'Porcentagem',

  // Produto
  'product.damage': 'Dano',
  'product.stain': 'Mancha',

  // Recibo
  'receipt.addressLabel': 'Endereço',
  'receipt.allYears': 'Todos os anos',
  'receipt.area': 'Área',
  'receipt.backButton': 'Voltar',
  'receipt.buyCredits': 'Comprar créditos',
  'receipt.cancelled': 'Cancelado',
  'receipt.cancelledBanner': 'Este pedido foi cancelado',
  'receipt.cancelledBy': 'Cancelado por',
  'receipt.cancelledDate': 'Data de cancelamento',
  'receipt.cancelledReason': 'Motivo do cancelamento',
  'receipt.card': 'Cartão',
  'receipt.cash': 'Dinheiro',
  'receipt.change': 'Troco',
  'receipt.creditsFinished': 'Créditos WhatsApp esgotados!',
  'receipt.customer': 'Cliente',
  'receipt.customerInfo': 'Informações do cliente',
  'receipt.customerName': 'Nome do cliente',
  'receipt.deliveryDate': 'Data de entrega',
  'receipt.discount': 'Desconto',
  'receipt.freeOfCharge': 'Gratuito',
  'receipt.generalTotal': 'Total geral',
  'receipt.grandTotal': 'Total final',
  'receipt.homeDelivery': 'Entrega em domicílio',
  'receipt.invalid': 'Recibo inválido',
  'receipt.items': 'Itens',
  'receipt.label': 'Etiqueta',
  'receipt.markAsDelivered': 'Marcar como entregue',
  'receipt.markAsReady': 'Marcar como pronto',
  'receipt.messageFailed': 'Mensagem não enviada',
  'receipt.messageSent': 'Mensagem enviada!',
  'receipt.new': 'Novo recibo',
  'receipt.noReceiptFound': 'Nenhum recibo encontrado',
  'receipt.notes': 'Observações',
  'receipt.onlyProEnterprise': 'Apenas Pro/Enterprise',
  'receipt.orderMarkedDelivered': 'Pedido marcado como entregue',
  'receipt.orderMarkedReady': 'Pedido marcado como pronto',
  'receipt.orderNumber': 'Número do pedido',
  'receipt.paid': 'Pago',
  'receipt.partialPayment': 'Pagamento parcial',
  'receipt.paymentMethod': 'Forma de pagamento',
  'receipt.phone': 'Telefone',
  'receipt.phoneNotFound': 'Telefone não encontrado',
  'receipt.piece': 'Peça',
  'receipt.preview': 'Pré-visualização',
  'receipt.printError': 'Erro de impressão',
  'receipt.printerConnectError': 'Não foi possível conectar a impressora',
  'receipt.remaining': 'Saldo restante',
  'receipt.remainingCredits': 'Créditos restantes',
  'receipt.reprint': 'Reimprimir',
  'receipt.scanQR': 'Escanear QR code',
  'receipt.searchAll': 'Todos',
  'receipt.searchBy': 'Pesquisar por',
  'receipt.searchName': 'Nome do cliente',
  'receipt.searchPhone': 'Telefone',
  'receipt.searchReceipt': 'N° recibo',
  'receipt.searchTitle': 'Pesquisar recibo',
  'receipt.sessionNotFound': 'Sessão não encontrada. Faça login novamente.',
  'receipt.status': 'Status',
  'receipt.thermalPrinter': 'Impressora térmica',
  'receipt.thisReceiptCancelled': 'Este recibo foi cancelado',
  'receipt.unknownError': 'Erro desconhecido',
  'receipt.whatsappNotConnected': 'WhatsApp não conectado!',
  'receipt.year': 'Ano',

  // Relatórios
  'reports.averageOrder': 'Pedido médio',
  'reports.ordersCount': 'Número de pedidos',
  'reports.salesReport': 'Relatório de vendas',
  'reports.totalSales': 'Total de vendas',

  // Serviços
  'service.carpetShort': 'Tapete',
  'service.dryCleaningShort': 'Limpeza',
  'service.ironingShort': 'Passagem',
  'service.dyeingShort': 'Tingimento',
  'service.shoeShineShort': 'Calçados',
  'service.tailoringShort': 'Costura',
  'service.washingShort': 'Lavagem',

  // Configurações
  'settings.africa': 'África',
  'settings.americas': 'Américas',
  'settings.asia': 'Ásia',
  'settings.asiaPacific': 'Ásia-Pacífico',
  'settings.europe': 'Europa',
  'settings.integrations': 'Integrações',
  'settings.notifications': 'Notificações',
  'settings.printer': 'Impressora',
  'settings.printerConnected': 'Impressora conectada',
  'settings.printerNotConnected': 'Impressora não conectada',
  'settings.printerSettings': 'Configurações da impressora',
  'settings.saveError': 'Não foi possível salvar as configurações',
  'settings.saved': 'Configurações salvas',
  'settings.testPrint': 'Impressão de teste',
  'settings.turkey': 'Turquia',

  // Cadastro
  'signup.errors.companyCodeRequired': 'Código da empresa obrigatório',
  'signup.errors.companyNameRequired': 'Nome da empresa obrigatório',
  'signup.errors.emailInvalid': 'E-mail inválido',
  'signup.errors.emailRequired': 'E-mail obrigatório',
  'signup.errors.ownerNameRequired': 'Nome do proprietário obrigatório',
  'signup.errors.signupFailed': 'Cadastro falhou',
  'signup.referral.bonus': 'Bônus de indicação',
  'signup.referral.title': 'Código de convite',
  'signup.companyDetails': 'Dados da empresa',
  'signup.errors.companyCodeTooShort': 'O código da empresa deve ter pelo menos 3 caracteres',
  'signup.fields.companyCode': 'Código da empresa',
  'signup.fields.companyName': 'Nome da empresa',
  'signup.fields.country': 'País',
  'signup.fields.email': 'E-mail',
  'signup.fields.ownerName': 'Nome completo',
  'signup.fields.phone': 'Telefone',
  'signup.haveAccount': 'Já tem conta? Entrar',
  'signup.placeholders.companyCode': 'ex.: cleanpro',
  'signup.placeholders.companyName': 'ex.: CleanPro Lavandaria',
  'signup.placeholders.email': 'ex.: joao@cleanpro.com',
  'signup.placeholders.ownerName': 'ex.: João Silva',
  'signup.placeholders.phone': 'ex.: +351 912 345 678',

  // Status
  'status.cancelled': 'Cancelado',
  'status.delivered': 'Entregue',
  'status.pending': 'Pendente',
  'status.pickup_in_progress': 'Coleta em andamento',
  'status.pickup_pending': 'Coleta pendente',
  'status.ready': 'Pronto',
  'status.received': 'Recebido',

  // Assinatura
  'subscription.buyNow': 'Comprar agora',
  'subscription.cancel': 'Cancelar assinatura',
  'subscription.contactSupport': 'Contatar suporte',
  'subscription.currentPlan': 'Plano atual',
  'subscription.currentUsage': 'Uso atual',
  'subscription.daysLeft': 'dias restantes',
  'subscription.endDate': 'Data de término',
  'subscription.expired': 'Expirado',
  'subscription.expiresOn': 'Expira em',
  'subscription.features': 'Funcionalidades',
  'subscription.loading': 'Carregando assinatura...',
  'subscription.monthly': 'Mensal',
  'subscription.monthlyLimit': 'Limite mensal',
  'subscription.noSubscription': 'Sem assinatura ativa',
  'subscription.payNow': 'Pagar agora',
  'subscription.plan': 'Plano',
  'subscription.pro': 'Pro',
  'subscription.renew': 'Renovar',
  'subscription.renewNow': 'Renovar agora',
  'subscription.startDate': 'Data de início',
  'subscription.title': 'Assinatura',
  'subscription.trial': 'Teste',
  'subscription.trialDaysLeft': 'dias de teste restantes',
  'subscription.upgrade': 'Fazer upgrade',
  'subscription.yearly': 'Anual',

  // Tickets de suporte
  'tickets.title': 'Tickets de suporte',
  'tickets.newTicket': 'Novo ticket',
  'tickets.noTickets': 'Nenhum ticket encontrado',
  'tickets.subject': 'Assunto',
  'tickets.description': 'Descrição',
  'tickets.created': 'Ticket de suporte criado',
  'tickets.createError': 'Não foi possível criar o ticket',
  'tickets.loadError': 'Não foi possível carregar os tickets',
  'tickets.messages': 'Mensagens',
  'tickets.typeMessage': 'Digite sua mensagem...',
  'tickets.closed': 'Fechado',
  'tickets.admin': 'Admin',
  'tickets.ratingSubmitted': 'Avaliação salva, obrigado!',
  'tickets.translationError': 'Erro de tradução',
  'tickets.status.open': 'Aberto',
  'tickets.status.closed': 'Fechado',
  'tickets.rating.excellent': 'Excelente',
  'tickets.rating.good': 'Bom',
  'tickets.rating.okay': 'Regular',
  'tickets.rating.bad': 'Ruim',
  'tickets.rating.veryBad': 'Muito ruim',

  // Toast
  'toast.logoTooLarge': 'O arquivo do logo é muito grande',
  'toast.logoUploadError': 'Não foi possível fazer upload do logo',
  'toast.uploadingLogo': 'Fazendo upload do logo...',

  // WhatsApp
  'whatsapp.title': 'WhatsApp',
  'whatsapp.connect': 'Conectar WhatsApp',
  'whatsapp.disconnect': 'Desconectar',
  'whatsapp.connected': 'Conectado',
  'whatsapp.scanQR': 'Escanear QR code',
  'whatsapp.status': 'Status',
  'whatsapp.credits': 'Créditos',
  'whatsapp.buyCredits': 'Comprar créditos',
  'whatsapp.creditPackages': 'Pacotes de créditos',
  'whatsapp.messages': 'Mensagens',
  'whatsapp.creditsRemaining': 'créditos restantes',
  'whatsapp.noCredits': 'Sem créditos disponíveis',
  'whatsapp.sendTest': 'Enviar mensagem de teste',
  'whatsapp.testSent': 'Mensagem de teste enviada',
  'whatsapp.testFailed': 'Mensagem de teste falhou',
  'whatsapp.templates': 'Modelos',
  'whatsapp.template': 'Modelo',
  'whatsapp.preview': 'Pré-visualização',
  'whatsapp.save': 'Salvar modelo',
  'whatsapp.saved': 'Modelo salvo',
  'whatsapp.orderReady': 'Pedido pronto',
  'whatsapp.orderDelivered': 'Pedido entregue',
  'whatsapp.receiptCreated': 'Recibo criado',

  // Relatório Z
  'zReport.title': 'Relatório Z',
  'zReport.byEmployee': 'Por funcionário',
  'zReport.byProduct': 'Por produto',
  'zReport.byService': 'Por serviço',
  'zReport.cardPayments': 'Pagamentos com cartão',
  'zReport.cashIn': 'Entradas',
  'zReport.cashOut': 'Saídas',
  'zReport.cashPayments': 'Pagamentos em dinheiro',
  'zReport.closingBalance': 'Saldo de fechamento',
  'zReport.creditPayments': 'Pagamentos a crédito',
  'zReport.custom': 'Personalizado',
  'zReport.daily': 'Diário',
  'zReport.endDate': 'Data de término',
  'zReport.freeOrders': 'Pedidos gratuitos',
  'zReport.generateReport': 'Gerar relatório',
  'zReport.monthly': 'Mensal',
  'zReport.newCustomers': 'Novos clientes',
  'zReport.openingBalance': 'Saldo de abertura',
  'zReport.printReport': 'Imprimir relatório',
  'zReport.returningCustomers': 'Clientes recorrentes',
  'zReport.selectDate': 'Selecionar data',
  'zReport.serviceBreakdown': 'Detalhamento por serviço',
  'zReport.startDate': 'Data de início',
  'zReport.totalCollected': 'Total cobrado',
  'zReport.totalItems': 'Total de itens',
  'zReport.totalOrders': 'Total de pedidos',
  'zReport.totalRefunds': 'Total de reembolsos',
  'zReport.totalRevenue': 'Receita total',
  'zReport.transferPayments': 'Transferências',
  'zReport.weekly': 'Semanal',
  'zreport.card': 'Cartão',
  'zreport.cash': 'Dinheiro',
  'zreport.date': 'Data',
  'zreport.orders': 'Pedidos',
  'zreport.print': 'Imprimir',
  'zreport.title': 'Relatório Z',
  'zreport.total': 'Total',

  'zReport.cashBoxStartNote': 'Saldo inicial do caixa',
  'zReport.todayCashNote': 'Dinheiro recebido hoje',
  'zReport.branchCollectionsNote': 'Cobranças próprias + outras filiais',
  'zReport.dailyExpensesNote': 'Despesas do dia',
  'customerCard.balanceZero': 'O saldo já é zero.',
  'customerCard.debtLabel': 'a dívida será eliminada',
  'customerCard.creditLabel': 'o crédito será eliminado',
  'customerCard.resetConfirm': 'O saldo será redefinido ({label}). Confirmar?',
  'customerCard.resetSuccess': 'Saldo redefinido com sucesso',
  'customerCard.resetError': 'Não foi possível redefinir o saldo',
  'customerCard.printTitle': 'Ficha do Cliente',
  'customerCard.heading': 'FICHA DO CLIENTE',
  'customerCard.tel1': 'TEL 1',
  'customerCard.tel2': 'TEL 2',
  'customerCard.address': 'ENDEREÇO',
  'customerCard.printButton': 'Imprimir ficha do cliente',
  'customerCard.resetting': 'Redefinindo...',
  'customerCard.resetBalance': 'Redefinir saldo',
  'tailoring.loadError': 'Não foi possível carregar os preços',
  'tailoring.nameRequired': 'Por favor, insira um nome de operação',
  'tailoring.invalidPrice': 'Por favor, insira um preço válido',
  'tailoring.addSuccess': 'Nova operação de costura adicionada!',
  'tailoring.saveError': 'Erro ao salvar',
  'tailoring.deleteConfirm': 'Tem certeza de que deseja excluir esta operação?',
  'tailoring.deleteSuccess': 'Operação excluída',
  'tailoring.deleteError': 'Erro ao excluir',
  'tailoring.saveSuccess': 'Preços de costura salvos!',
  'tailoring.addNewTitle': 'Adicionar nova operação de costura',
  'tailoring.operationNameLabel': 'Nome da operação',
  'tailoring.priceLabel': 'Preço',
  'tailoring.iconLabel': 'Ícone (Emoji)',
  'tailoring.operationNamePlaceholder': 'Ex: Costura de gola',
  'tailoring.savePricesHint': 'Clique em Salvar para salvar os preços',
  'tailoring.addCustomHint': 'Use o botão + para adicionar uma operação personalizada',
  'reportsList.title': 'Relatório de lista de recibos',
  'reportsList.startDate': 'Data de início',
  'reportsList.endDate': 'Data de fim',
  'reportsList.search': 'Pesquisar',
  'reportsList.loading': 'Carregando...',
  'reportsList.description': 'Todos os recibos registrados ou entregues neste intervalo de datas são listados',
  'reportsList.empty': 'Nenhum recibo encontrado neste intervalo de datas',
  'reportsList.changeDateRange': 'Selecione um intervalo de datas diferente',
  'reportsList.categoryBreakdown': 'Distribuição por categoria',
  'reportsList.unknown': 'Desconhecido',
  'reportsList.cancelReason': 'Motivo do cancelamento:',
  'reportsList.excelDownloaded': 'Arquivo Excel baixado',
  'reportsList.excelError': 'Não foi possível criar o arquivo Excel',
  'reportsList.totalReceipt': 'Total de recibos',
  'reportsList.activeReceipt': 'Recibos ativos',
  'reportsList.loadError': 'Não foi possível carregar a lista de recibos',
  'reportsList.dateError': 'A data de início não pode ser posterior à data de fim',
  'charts.revenue': 'Receita',
  'charts.orders': 'Pedidos',
  'charts.pieces': 'Número de peças',
  'charts.receipts': 'Número de recibos',
  'charts.loadError': 'Não foi possível carregar os dados',

  'customerStatement.selectDateRange': 'Selecionar intervalo de datas',
  'customerStatement.thisMonth': 'Este mês',
  'customerStatement.lastMonth': 'Mês passado',
  'customerStatement.allTime': 'Todo o período',
  'customerStatement.startDate': 'Data de início',
  'customerStatement.endDate': 'Data de fim',
  'customerStatement.printPDF': 'Imprimir extrato (PDF)',
  'customerStatement.title': 'EXTRATO DE CONTA',
  'customerStatement.customerName': 'Nome do cliente',
  'customerStatement.phone': 'Telefone',
  'customerStatement.address': 'Endereço',
  'customerStatement.openingBalance': 'Saldo inicial',
  'customerStatement.closingBalance': 'Saldo final',
  'customerStatement.description': 'Descrição',
  'customerStatement.type': 'Tipo',
  'customerStatement.debit': 'Débito',
  'customerStatement.credit': 'Crédito (recebido)',
  'customerStatement.total': 'TOTAL',
  'customerStatement.cancelled': 'CANCELADO',
  'customerStatement.payment': 'Pagamento',
  'customerStatement.items': 'itens',
  'customerStatement.noTransactions': 'Não há transações no período selecionado.',
  'customerStatement.statementDate': 'Data do extrato',

  'tailoring.title': 'Serviços de Alfaiataria',
  'tailoring.addNew': 'Nova Operação',
  'tailoring.subtitle': 'Aqui você pode atualizar os preços dos serviços de alfaiataria',
  'tailoring.addNewDescription': 'Adicionar um tipo de operação de alfaiataria personalizado',
  'tailoring.add': 'Adicionar',
  'tailoring.savePrices': 'Salvar preços',
  'tailoring.default': 'Padrão',
  'tailoring.infoTitle': 'Informação',
  'tailoring.info1': 'Após alterar os preços, clique em "Salvar preços"',
  'tailoring.info2': 'Com "Nova Operação" você pode adicionar tipos de operações personalizados',
  'tailoring.info3': 'As operações personalizadas podem ser excluídas com o ícone de lixeira',
  'tailoring.info4': 'Esses preços são usados ao criar pedidos com serviço de alfaiataria',
  'tailoring.info5': 'Você pode definir um preço separado para cada operação de alfaiataria',
  'tailoring.info6': 'Os preços são calculados automaticamente ao adicionar ao carrinho',

  'hardware.title': 'Loja de Hardware',
  'hardware.subtitle': 'Impressoras de recibos, etiquetas e dispositivos Caller ID',
  'hardware.cart': 'Carrinho',
  'hardware.infoTitle': 'Informação',
  'hardware.infoText': 'Estes produtos de hardware estão atualmente disponíveis para compra apenas na Turquia. Estão listados para fins informativos para outros países.',
  'hardware.myCart': 'Meu Carrinho',
  'hardware.cartEmpty': 'Carrinho vazio',
  'hardware.vatSuffix': '+ IVA',
  'hardware.total': 'Total',
  'hardware.checkout': 'Prosseguir para pagamento',
  'hardware.receiptPrinters': 'Impressoras de recibos',
  'hardware.receiptPrintersSubtitle': 'Impressoras térmicas 80mm com cortador automático',
  'hardware.compatibilityTitle': 'Compatibilidade CleandySoft',
  'hardware.receiptCompatText': 'Funciona com todas as impressoras térmicas 80mm com cortador automático.',
  'hardware.labelPrinters': 'Impressoras de etiquetas',
  'hardware.labelPrintersSubtitle': 'Impressoras matriciais, 76mm/57mm (Epson TM-U220, Bixolon SRP-270)',
  'hardware.testedModels': 'Modelos testados',
  'hardware.labelCompatText': 'Testado para Epson TM-U220 e Bixolon SRP-270. Outras marcas ou modelos podem ter problemas.',
  'hardware.callerIdTitle': 'Dispositivos Caller ID',
  'hardware.callerIdSubtitle': 'Identificação de chamadas de clientes',
  'hardware.compatibilityNote': 'Nota de compatibilidade',
  'hardware.callerIdCompatText': 'Testado apenas para modelo CIDShow 2 linhas. Outras marcas ou modelos podem funcionar mas não são garantidos.',
  'hardware.barcodeScanners': 'Leitores de código de barras',
  'hardware.barcodeScannerSubtitle': 'Leitores USB de código de barras e QR',
  'hardware.barcodeCompatText': 'Todos os leitores 2D podem funcionar com CleandySoft. Leitores em modo USB HID são suportados automaticamente.',
  'hardware.driverDownloads': 'Downloads de drivers e software',
  'hardware.driverDownloadsText': 'Recomenda-se baixar o driver apropriado antes de conectar a impressora.',
  'hardware.onlyTurkey': 'Este produto só está disponível para compra na Turquia',
  'hardware.addedToCart': 'Adicionado ao carrinho!',
  'hardware.available': 'Disponível',
  'hardware.info': 'Info',
  'hardware.features': 'Características',
  'hardware.addToCart': 'Adicionar ao carrinho',
  'hardware.infoOnly': 'Apenas informativo',
  'expenses.expenseType': 'Tipo de despesa',
  'expenses.allBranches': 'Todas as filiais',
  'expenses.noBranch': 'Sem filial',
  'expenses.allTypes': 'Todos os tipos',
  'expenses.categoryBy': 'Por categoria',
  'expenses.records': 'registros',
  'expenses.exportExcel': 'Excel',
  'expenses.excelError': 'Não foi possível criar o arquivo Excel',
  'expenses.branchSelect': 'Selecionar filial',
  'expenses.noBranchSelected': '— Nenhuma filial selecionada —',
  'expenses.myBranch': 'Minha filial',
  'expenses.canOnlyDeleteToday': 'Você só pode excluir as despesas inseridas hoje.',

  // Payment dialog
  'order.selectPaymentMethod': 'Selecione o método de pagamento',
  'payment.amountToPay': 'Valor a pagar',
  'payment.remaining': 'Restante',
  'payment.cash': 'Dinheiro',
  'payment.creditCard': 'Cartão de Crédito (POS)',
  'payment.account': 'Conta',
  'payment.onDelivery': 'Na Entrega',
  'payment.splitPayment': 'Pagamento Dividido',
  'payment.mealCard': 'Cartão Refeição',
  'payment.amount': 'Valor do pagamento',
  'payment.enterAmount': 'Introduza o valor do pagamento',
  'payment.madePayments': 'Pagamentos efetuados',
  'toast.selectPaymentMethodFirst': 'Selecione primeiro um método de pagamento',
  'logout': 'Sair',
  'orderCreate.allCategories': 'Todos',
  'orderCreate.select': 'Selecionar',

  // Order screen
  'orderCreate.cart': 'Carrinho',
  'orderCreate.totalPieces': 'Total de Peças',
  'orderCreate.plannedDelivery': 'Entrega Prevista',
  'orderCreate.payment': 'Pagamento',
  'orderCreate.save': 'Guardar',
  'orderCreate.continue': 'Continuar',
  'orderCreate.selectCustomer': 'Selecionar Cliente',
  'orderCreate.selectCustomerPlaceholder': 'Selecionar cliente',
  'orderCreate.change': 'Alterar',
  'orderCreate.balance': 'Saldo',
  'orderCreate.searchCustomer': 'Pesquisar por nome, telefone ou morada... (exemplo: joao+912345678)',
  'orderCreate.newCustomer': 'Novo Cliente',
  'orderCreate.customerName': 'Nome e Apelido',
  'orderCreate.customerPhone': 'Telefone',
  'orderCreate.customerEmail': 'Email',
  'orderCreate.customerAddress': 'Morada',
  'orderCreate.addCustomer': 'Adicionar Cliente',
  'orderCreate.customer': 'Cliente',
  'orderCreate.serviceType': 'Tipo de Serviço',
  'orderCreate.clickToSelect': 'Clique para selecionar',
  'orderCreate.deliveryDate': 'Data de Entrega',
  'orderCreate.details': 'Detalhes',
  'orderCreate.itemDetails': 'Detalhes do Artigo',
  'orderCreate.tailoringOperations': 'Operações de Costura',
  'orderCreate.tailoringTitle': 'Operações de Costura',
  'orderCreate.discount': 'Desconto',
  'orderCreate.discountLabel': 'Desconto (%)',
  'orderCreate.debt': 'Dívida',
  'orderCreate.credit': 'Crédito',
  'orderCreate.homeDelivery': 'Entrega ao Domicílio',
  'orderCreate.homeDeliveryAddress': 'Morada',
  'orderCreate.addressRequired': 'Morada obrigatória!',
  'orderCreate.pickupFromAddress': 'O motorista recolhe na morada',
  'orderCreate.subtotal': 'Subtotal',
  'orderCreate.grandTotal': 'Total Geral',
  'subscription.referralDesc': 'Quando um amigo que convidar se registar e se tornar membro, ganha 1 mês extra! Só enviar o convite não basta.',
};
